// The decision post's verdict badge. The proposal → verdict → execution row went with algo.boo's proposal book (lane BOO2).
import { refusalLabel } from '../format/refusals.js'
import { cx } from './cx.js'
import { Pill } from './primitives.js'

export function VerdictBadge({ verdict, codes = [], className }: { verdict: 'approved' | 'refused'; codes?: readonly string[]; className?: string }) {
  if (verdict === 'approved')
    return (
      <Pill tone="good" icon="check" className={className}>
        Approved
      </Pill>
    )
  return (
    <span className={cx('inline-flex flex-wrap items-center gap-1', className)}>
      <Pill tone="bad" icon="close" title={codes.join(', ') || 'Refused by policy'}>
        Refused
      </Pill>
      {codes.map((c) => (
        <span key={c} title={c} className="inline-flex h-6 items-center rounded-md border border-[color-mix(in_oklab,var(--loss)_35%,transparent)] px-1.5 font-mono text-[11px] text-loss">
          {refusalLabel(c)}
        </span>
      ))}
    </span>
  )
}
